export default {
  Profile: {
    Home: {
      update_success: 'Usuário atualizado com sucesso',
    },
    Header: {
      subtitle: 'Configuração de usuário',
      title: 'Perfil',
    },
  },
}
